<template>
  <dialog :class="['modal', { 'modal-open': open }]">
    <div class="modal-box overflow-visible">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-ghost absolute top-2 right-2"
          @click="$emit('update:open', false)"
        >
          ✕
        </button>
      </form>

      <h3 class="text-error mb-4 text-lg font-bold">
        <i class="fa-solid fa-virus mr-2"></i>
        Cấu hình Khai Thác
      </h3>

      <div v-if="target" class="alert alert-warning mb-4 shadow-sm">
        <div>
          <h4 class="text-xs font-bold uppercase opacity-70">Mục tiêu</h4>
          <div class="mt-1 flex flex-col text-sm">
            <span><i class="fa-solid fa-desktop w-5"></i> {{ target.ip }}</span>
            <span
              ><i class="fa-solid fa-user w-5"></i> {{ target.username }}</span
            >
            <span
              ><i class="fa-solid fa-key w-5"></i> {{ target.password }}</span
            >
          </div>
        </div>
      </div>

      <div class="border-base-300 bg-base-100 mb-4 rounded-lg border p-4">
        <!-- Bruteforce Section -->
        <div class="mb-4">
          <label class="label pt-0">
            <span class="label-text font-semibold">Module Bruteforce</span>
          </label>
          <VersionSelect
            type="bruteforce"
            placeholder="Tìm kiếm module Bruteforce..."
            v-model="selectedBruteforceId"
          />
        </div>

        <!-- Spread LAN Section -->
        <div>
          <label class="label pt-0">
            <span class="label-text font-semibold">Module Lây Lan</span>
          </label>
          <VersionSelect
            type="spread_lan"
            placeholder="Tìm kiếm module Lây Lan..."
            v-model="selectedSpreadLanId"
          />
        </div>
      </div>

      <div class="modal-action">
        <button class="btn" @click="$emit('update:open', false)">Hủy</button>
        <button
          class="btn btn-error"
          :disabled="!canExploit"
          @click="handleExploit"
        >
          Khai Thác
        </button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { axios_instance } from "@/api/api";
import VersionSelect from "./VersionSelect.vue";
// import type { version } from "@/components/VersionControl";
// import { useQuery } from "@tanstack/vue-query";
import { computed, ref } from "vue";
// import { useRoute } from "vue-router";
import { toast } from "vue3-toastify";

interface BruteForceResult {
  id: string;
  agent_id: string;
  scan_id: string;
  ip: string;
  username: string;
  password: string;
  created: number;
  modified: number;
}

const props = defineProps<{
  open: boolean;
  target: BruteForceResult | null; // The selected result row
}>();

const emit = defineEmits<{
  "update:open": [value: boolean];
  exploited: [data: unknown];
}>();

// const route = useRoute();
const selectedBruteforceId = ref("");
const selectedSpreadLanId = ref("");

const canExploit = computed(() => {
  if (!props.target) return false;
  // Must select at least one module
  return !!selectedBruteforceId.value || !!selectedSpreadLanId.value;
});

const handleExploit = async () => {
  try {
    if (!props.target) {
      toast.error("Không có thông tin mục tiêu!");
      return;
    }

    const payload = {
      id: props.target.id,
      version_bruteforce: selectedBruteforceId.value,
      version_spread_lan: selectedSpreadLanId.value,
      timeout: 0,
    };

    await axios_instance.post(
      "/api/v1/view/password-detection/bruteforce",
      payload,
    );

    toast.success("Đã gửi lệnh KHAI THÁC thành công!");
    emit("exploited", true);
    emit("update:open", false);
  } catch (error) {
    console.error(error);
    toast.error("Gửi lệnh khai thác thất bại!");
  }
};
</script>
